import script from "./DocumentClientAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentClientAddress.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentClientAddress.vue?vue&type=style&index=0&id=40018b99&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40018b99"]])

export default __exports__